/* global warehouseCode */
// import _ from 'lodash';
// import SecureLS from 'secure-ls';
import config from 'store/_config'
import { segmentIdentifyCurrentMember } from '../utils/segment/identify'
import {
  axiosInstance as axios,
  convertNestedPostDataIntoObject,
  handleAxiosErrors,
  objectEquals,
  isEmpty,
} from '_utils'
import { createAlert } from '../dom/window'
import { handleNewAddressFieldUpdate } from '../actions/addressActions'
import {
  handleFieldUpdate as handleCheckoutFieldUpdate,
  handleNewAddressFieldUpdate as handleCheckoutNewAddressFieldUpdate,
} from '../actions/checkoutActions'
import { handleFieldUpdate } from '../actions/paymentsActions'
import { toggleLoading } from './defaultActions'
import { LS, setItemInStorageWithExpiry, getItemFromStorageWithExpiry } from '../store/localStorage'
import { axiosRequestEnCustomerDiscounts } from '../actions/productsActions'
import { convertPromoDealFilters } from '../selectors/productSelectors'
import {
  updateDeliveryInfoFields,
  updateBackorderNotificationFields,
  updateFeatureDealsFields,
  updateAccountPayableFields,
  axiosCreateMemberInfo,
  axiosUpdateChileMemberInfo,
  axiosDeleteChildMemberInfo,
  axiosDoItLaterMemberInfo,
} from './myAccountActions'

const setConsolidationDay = (params) => {
  return {
    type: 'SET_CONSOLIDATION_DAY',
    params,
  }
}

const clearConsolidationDay = () => {
  return {
    type: 'CLEAR_CONSOLIDATION_DAY',
  }
}

export const toggleUpdateMemberLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_UPDATE_MEMBER_LOADING',
      value,
    })
  }
}

export const togglePdfViewModal = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PDF_VIEW_MODAL',
      value: value,
    })
  }
}

export const togglePdfViewModalLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'PDF_VIEW_LOADING',
      value: value,
    })
  }
}

export const setPdfViewData = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PDF_VIEW_DATA',
      value: value,
    })
  }
}

export const togglePdfStatementLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'PDF_LOADING',
      value: { value },
    })
  }
}

export const setPdfStatementLink = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PDF',
      value: { value },
    })
  }
}

export const updateUserDetail = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_USER',
      target: key,
      value: value,
    })
  }
}

export const getDeliveryPreferences = () => {
  return async (dispatch, getState) => {
    const state = getState()
    const { url, query } = config.checkout.deliveryDates

    dispatch(toggleUpdateMemberLoading(true))

    try {
      const response = await axios.get(url, {
        params: {
          query: query,
        },
        withCredentials: true,
      })

      const appDeliveryDates = response?.data?.data?.readAppDeliveryDates?.edges?.map((x) => {
        return x?.node
      })
      if (appDeliveryDates.length > 0) {
        const consolidationDay = appDeliveryDates.find((x) => x?.ConsolidationDay === true)

        if (consolidationDay?.ConsolidationDay === true || state?.user?.details?.IsConsolidationEnabled === true) {
          dispatch(
            setConsolidationDay({
              isConsolidationEnabled: true,
              day: consolidationDay?.Day || '',
              date: consolidationDay?.Date || '',
              deliveryDates: appDeliveryDates,
            })
          )
        } else {
          dispatch(
            setConsolidationDay({
              isConsolidationEnabled: false,
              day: '',
              date: '',
              deliveryDates: appDeliveryDates,
            })
          )
        }
      }
      dispatch(toggleUpdateMemberLoading(false))
    } catch (error) {
      handleAxiosErrors(error)
      dispatch(toggleUpdateMemberLoading(false))
    }
  }
}

// USER
export const getUserWarehouseCode = (warehouseCode) => {
  return (dispatch, getState) => {
    if (!window?.warehouseCode) return

    const code = warehouseCode || window?.warehouseCode

    dispatch({
      type: 'UPDATE_USER',
      target: 'warehouseCode',
      value: code,
    })
  }
}

export const getGlobalConfig = () => {
  return async (dispatch, getState) => {
    // Get global config from local storage and use it until its expired
    let configInStorage = getItemFromStorageWithExpiry('globalConfig', window.currentMemberID)
    // console.log("configInStorage ==== getGlobalConfig" , {configInStorage})

    if (configInStorage) {
      const globalConfig = configInStorage
      const categoryTopFilters = configInStorage?.CategoryTopFilters
      const categoryFilters = convertPromoDealFilters(categoryTopFilters)
      dispatch({
        type: 'SET_GLOBAL_CONFIG',
        value: globalConfig,
      })
      dispatch({
        type: 'SET_GLOBAL_CONFIG_FILTERS',
        value: categoryFilters,
      })
    } else {
      const { readGlobalConfig } = config
      const { url, query } = readGlobalConfig

      try {
        const globalConfigResponse = await axios.get(url, {
          withCredentials: true,
          params: {
            query,
          },
        })

        // Storing global config in local storage after API Call and set expriry of 15 minutes
        setItemInStorageWithExpiry(
          'globalConfig',
          window.currentMemberID,
          globalConfigResponse?.data?.data?.readGlobalConfig,
          2
        )

        const globalConfig = globalConfigResponse?.data?.data?.readGlobalConfig
        const categoryTopFilters = globalConfigResponse?.data?.data?.readGlobalConfig.CategoryTopFilters
        const categoryFilters = convertPromoDealFilters(categoryTopFilters)
        dispatch({
          type: 'SET_GLOBAL_CONFIG',
          value: globalConfig,
        })
        dispatch({
          type: 'SET_GLOBAL_CONFIG_FILTERS',
          value: categoryFilters,
        })
      } catch (error) {
        handleAxiosErrors(error)
      }
    }
  }
}

export const getCalculatedState = (initState, comingData) => {
  return (dispatch, getState) => {
    let obj1 = {}
    let obj2 = {}
    let obj3 = {}
    let obj4 = {}
    let stateKeys = Object.keys(initState)

    for (let [key, value] of Object.entries(comingData)) {
      let isString = typeof key == 'string'
      // console.log("🚀 ~ file: userActions.js ~ line 178 ~ getCalculatedState ~ isString" , initState.find(str => str == "AP_ContactNumber"))

      if (isString) {
        if (stateKeys.includes('deliveryInformation') && key.split('_')[0] === 'DP') {
          obj1[key.split('_')[1]] = value
          dispatch(updateDeliveryInfoFields(key.split('_')[1], value))
        } else if (stateKeys.includes('backorderNotification') && key.split('_')[0] === 'BN') {
          obj2[key.split('_')[1]] = value
          dispatch(updateBackorderNotificationFields(key.split('_')[1], value))
        } else if (stateKeys.includes('featureDeals') && key.split('_')[0] === 'FD') {
          obj3[key.split('_')[1]] = value
          dispatch(updateFeatureDealsFields(key.split('_')[1], value))
        } else if (stateKeys.includes('accountPayable') && key.split('_')[0] === 'AP') {
          obj4[key.split('_')[1]] = value
          dispatch(updateAccountPayableFields(key.split('_')[1], value))
        }
      }
    }
    if (!isEmpty(obj1)) {
      delete obj1.PreferredDeliveryDay
      delete obj1.PreferredDeliveryTimes
      // if(!isEmpty(obj1)) {
      if (objectEquals(obj1, obj2)) {
        dispatch(updateBackorderNotificationFields('sameAsDelivery', true))
      }

      if (objectEquals(obj1, obj3)) {
        dispatch(updateFeatureDealsFields('sameAsDelivery', true))
      }

      if (objectEquals(obj1, obj4)) {
        dispatch(updateAccountPayableFields('sameAsDelivery', true))
      }
      //  }
    }
    // console.log("🚀 ~ file: userActions.js ~ line 174 ~ getCalculatedState ~ initState", [obj1 , obj2 , obj3 , obj4])
  }
}

export const getUserCredentials = (store) => {
  return async (dispatch, getState) => {
    const state = getState()

    const triggeredDiscount = LS.get('triggeredDiscount')

    let customerID = 0

    if (typeof state.supplier.activeCustomer.id != 'undefined') {
      customerID = state.supplier.activeCustomer.id
    } else if (window.placeOnBehalfOfID !== undefined && window.placeOnBehalfOfID > 0) {
      customerID = window.placeOnBehalfOfID
    }
    if (!triggeredDiscount) {
      await dispatch(triggerDiscount(customerID))

      if (window?.pageURL === 'checkout') {
        await dispatch(setDiscountSyncing(true))

        const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

        while (1) {
          try {
            const enCustomerDiscountsDataResponse = await axiosRequestEnCustomerDiscounts(state, customerID)
            const discountSyncing = !!enCustomerDiscountsDataResponse?.data?.data?.readEnCustomerDiscounts
              ?.IsDiscountSyncing

            if (discountSyncing === false) {
              LS.set('triggeredDiscount', true)
              await dispatch(setDiscountSyncing(false))
              break
            }
          } catch (error) {
            handleAxiosErrors(error)
          }

          await sleep(2000)
        }
      }
    }

    const { authentication } = config
    let { url, query } = authentication
    let isOrderOnBehalfOf = customerID ? true : false
    query = query.replace(/{PurchasingUser}/, isOrderOnBehalfOf)
    dispatch(toggleUpdateMemberLoading(true))
    return axios
      .get(url, {
        withCredentials: true,
        params: {
          query,
        },
      })
      .then(async (response) => {
        const data = response.data.data.readCurrentMember
        let defaultSavedCreditCardID
        console.log('data holder', data)
        if (isSubWholesaler) {
          if (data.ChildSavedCreditCard?.ID == 0) {
            defaultSavedCreditCardID = data?.SavedCreditCard?.ID
          } else {
            defaultSavedCreditCardID = data?.ChildSavedCreditCard?.ID || null
            data.SavedCreditCard = data?.ChildSavedCreditCard
          }
        } else {
          defaultSavedCreditCardID = data?.SavedCreditCard?.ID || null
        }
        const state = data?.EnState || null

        if (data) {
          let userDetails = { ...data }
          if (window.isSubWholesaler || window.isSubSupplier) {
            userDetails = {
              ...userDetails,
              FirstName: data?.UserRole == null ? window.currentMemberFirstName : data?.FirstName,
              Surname: data?.Surname || window.currentMemberSurname,
              UserRole: data?.UserRole || window.currentMemberUserRole,
              Mobile: data?.Mobile || window.currentMemberMobile,
              Email: data?.Email || window.currentMemberEmail,
            }
          }
          dispatch(
            setUserCredentials({
              user: data.ID,
              base_group: '', // TODO: Remove later
              key: data.TempIDHash,
              externalID: '', // TODO: Remove later
              superWholesalerID: '', // TODO: Remove later
              parentID: data?.Parent?.ID || null,
              Is3PL: data?.Is3PL || false,
              Is3PLMEL: data?.Is3PLMEL || false,
              Is3PLSYD: data?.Is3PLSYD || false,
              Is3PLCAI: data?.Is3PLCAI || false,
              Is3PLADE: data?.Is3PLADE || false,
              Is3PLBRIS: data?.Is3PLBRIS || false,
              FirstName: data?.FirstName,
              Company: data?.Company,
              DefaultLocationForSupplier: data?.DefaultLocationForSupplier || '',
              defaultDeliveryAddressID: data?.DeliveryAddress?.ID || null,
              defaultSavedCreditCardID: defaultSavedCreditCardID,
              HideFreightIncreaseNotification: data?.HideFreightIncreaseNotification,
              isSuperWholesaler: window?.isSuperWholesaler || false,
              isSubWholesaler: window?.isSubWholesaler || false,
              isSupplier: window?.supplierID > 0,
              supplierID: window?.supplierID,
              customerID: customerID,
              cartItemCount: window?.cartItemCount || 0,
              calculatedTotalLoyaltyPoints: parseInt(data?.CalculatedTotalLoyaltyPoints) || 0,
              HideQLDCustomerPopup: data?.HideQLDCustomerPopup || true,
              ChargeArea: data?.ChargeArea || 0,
              EnLocationID: data?.EnLocationID || 1,
              HidePopup: data?.HidePopup,
              // base_group: GroupID,
              // externalID: typeof(ExternalMemberID) != 'undefined' ? Number(ExternalMemberID) : '',
              // superWholesalerID: typeof(data.super_wholesaler_id) != 'undefined' && data.super_wholesaler_id ? Number(data.super_wholesaler_id) : null,
            })
          )
          let currentState = getState()
          let myAccount = currentState?.myAccount
          dispatch(getCalculatedState(myAccount, data))

          dispatch({
            type: 'UPDATE_USER_DETAILS',
            details: {
              ...userDetails,
            },
          })

          // const { readSubChildrenAccount } = config
          // let { url, query } = readSubChildrenAccount

          // await axios
          //   .get(url, {
          //     withCredentials: true,
          //     params: {
          //       query,
          //     },
          //   })
          //   .then(async (response) => {
          //     const data = response.data.data.readSubChildrenAccount
          //     if (data) {
          //       dispatch({
          //         type: 'UPDATE_CHILD_USER_DETAILS',
          //         childetails: {
          //           ...data,
          //         },
          //       })
          //     } else {
          //       console.log('Invalid response')
          //     }
          //   })
          // .catch((error) => handleAxiosErrors(error))
          dispatch(toggleUpdateMemberLoading(false))
          dispatch(handleCheckoutFieldUpdate('selectedCreditCard', defaultSavedCreditCardID))
          dispatch(handleFieldUpdate('selectedCreditCard', defaultSavedCreditCardID))
          dispatch(handleNewAddressFieldUpdate('state', state))
          dispatch(handleCheckoutNewAddressFieldUpdate('state', state))
          dispatch(updateUserDetail('showLoyaltyModal', showLoyaltyModal(data?.SurveyDisplayCount)))

          segmentIdentifyCurrentMember(data)
        } else {
          createAlert(
            {
              message: 'Please log in to access this service',
            },
            'error'
          )
          console.log('Invalid response')
        }
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const triggerDiscount = (memberID = null) => {
  console.log('trigger,memberID', memberID)
  return (dispatch, getState) => {
    const store = getState()
    console.log('store====', store)
    const { triggerDiscount } = config
    let { url, query } = triggerDiscount

    const variables = {}
    console.log(memberID)
    if (memberID) {
      variables['ID'] = memberID
    }

    // return axios
    //   .post(
    //     url,
    //     {
    //       query,
    //       variables,
    //     },
    //     {
    //       withCredentials: true,
    //     }
    //   )
    //   .catch((e) => {
    //     if (window?.isLocalhost) {
    //       return {}
    //     }
    //   })
  }
}

export const getUserCredentialsGraphQL = (store) => {
  return (dispatch, getState) => {
    const { authenticationGraphQL } = config
    const { url, query } = authenticationGraphQL

    return axios
      .get(url, {
        params: {
          query: query,
        },
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data.data.readElvantiElasticMemberInfos.edges[0].node
        const { MemberID, GroupID, MemberTempHash, ExternalID } = data

        dispatch(
          setUserCredentials({
            user: MemberID,
            base_group: GroupID,
            key: MemberTempHash,
            externalID: typeof ExternalID != 'undefined' ? Number(ExternalID) : '',
          })
        )
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

//depricated
/*export const getWholesaleUserDetails = () => {
    return (dispatch, getState) => {
        let { url, query } = config.members.authentication;

        return axios.get(url, {
            params: {
                query: query
            },
            withCredentials: true
        }).then((response) => {
            const data = response.data.data.readCurrentMember;

            const DefaultDeliveryAddressID = data.DeliveryAddress.ID
            const State = data.DeliveryAddress.State
            const DefaultSavedCreditCardID = data.SavedCreditCard.ID;

            dispatch({
                type: 'UPDATE_USER_DETAILS',
                details: {
                    defaultCreditCardID: DefaultSavedCreditCardID,
                    defaultDeliveryAddressID: DefaultDeliveryAddressID,
                },
            });

            dispatch(handleCheckoutFieldUpdate('selectedCreditCard', DefaultSavedCreditCardID));

            dispatch(handleNewAddressFieldUpdate('state', State));
            dispatch(handleCheckoutNewAddressFieldUpdate('state', State));
        }).catch(error => handleAxiosErrors(error));
    };
};*/
export const setUserCredentials = (params) => {
  return (dispatch, getState) => {
    // LS.set('user', params);
    dispatch({
      type: 'SET_USER_CREDENTIALS',
      params: params,
    })

    // TODO: Remove this OLD getWholesaleUserDetails() and move all usage to a better function
    // Get user details
    // dispatch(getWholesaleUserDetails());
  }
}

export const setDiscountSyncing = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_DISCOUNT_SYNCING',
      value,
    })
  }
}

export const forceLogin = (selectedUser) => {
  return (dispatch, getState) => {
    const store = getState()

    if (store.isLoading) {
      return
    }

    dispatch(toggleLoading(true))

    const selectedUserID = typeof selectedUser.value != 'undefined' ? selectedUser.value : 0
    let { url, query } = config.members.orderOnBehalf

    return axios
      .post(
        url,
        {
          query: query,
          variables: {
            MemberID: selectedUserID,
          },
        },
        {
          withCredentials: true,
        }
      )
      .then(async (response) => {
        dispatch(toggleLoading(false))

        const { data } = response

        if (response.data.data.orderOnBehalf !== null) {
          console.log('Success, refreshing browser')
          LS.set('triggeredDiscount', false)
          localStorage.removeItem('isMarketingSurveyShow')
          setTimeout(() => {
            window.location.reload()
          }, 300)
        } else {
          createAlert(data, 'error')
        }
      })
      .catch((error) => {
        dispatch(toggleLoading(false))
        handleAxiosErrors(error)
      })
  }
}

export const updateMemberInfo = (postData) => {
  return async (dispatch, getState) => {
    dispatch(toggleUpdateMemberLoading(true))

    try {
      const response = await axiosUpdateMemberInfo(postData)
      const data = response?.data?.data?.updateMemberInfo
      dispatch({
        type: 'UPDATE_USER_DETAILS',
        details: {
          ...data,
        },
      })
      dispatch(toggleUpdateMemberLoading(false))
    } catch (error) {
      dispatch(toggleUpdateMemberLoading(false))
      handleAxiosErrors(error)
    }
  }
}

export const createChildMemberInfo = (postData, isEditing) => {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch(toggleUpdateMemberLoading(true))
    try {
      const response = isEditing ? await axiosUpdateChileMemberInfo(postData) : await axiosCreateMemberInfo(postData)
      if (response) {
        createAlert(
          {
            message: isEditing ? 'User Updated Successfully' : 'User Created Successfully',
          },
          'success'
        )
        dispatch(getUserCredentials())
      }
    } catch (error) {
      dispatch(toggleUpdateMemberLoading(false))
      handleAxiosErrors(error)
    }
  }
}

export const deleteChildMemberInfo = (id) => {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch(toggleUpdateMemberLoading(true))
    try {
      const response = await axiosDeleteChildMemberInfo(id)
      if (response) {
        createAlert(
          {
            message: 'User Deleted Successfully',
          },
          'success'
        )

        dispatch({ type: 'DELETE_CHILD_USER_DETAILS', id })

        await dispatch(getUserCredentials())
      }
    } catch (error) {
      dispatch(toggleUpdateMemberLoading(false))
      handleAxiosErrors(error)
    }
  }
}

export const updateDoItLaterMemberInfo = (postData) => {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch(toggleUpdateMemberLoading(true))
    try {
      const response = await axiosDoItLaterMemberInfo(postData)
      if (response) {
        // createAlert(
        //   {
        //     message: 'User Deleted Successfully',
        //   },
        //   'success'
        // )
        // dispatch({ type: 'DELETE_CHILD_USER_DETAILS', id })
        // await dispatch(getUserCredentials())
      }
    } catch (error) {
      dispatch(toggleUpdateMemberLoading(false))
      handleAxiosErrors(error)
    }
  }
}

export const axiosUpdateMemberInfo = (postData) => {
  let { url, query } = config.members.update
  const [mutationParams, inputParams, finalData] = convertPostDataIntoMutationParams(
    convertUpdateMemberPostData(postData)
  )

  query = query.replace('{mutationParams}', mutationParams).replace('{inputParams}', inputParams)

  return axios.post(
    url,
    {
      query,
      variables: finalData,
    },
    {
      withCredentials: true,
    }
  )
}
export const axiosCreateMember = (postData) => {
  let { url, query } = config.members.create

  const [mutationParams, inputParams, finalData] = convertPostDataIntoMutationParams(
    convertUpdateMemberPostData(postData)
  )

  query = query.replace('{mutationParams}', mutationParams).replace('{inputParams}', inputParams)

  return axios.post(
    url,
    {
      query: query,
      variables: finalData,
    },
    {
      withCredentials: true,
    }
  )
}
export const axiosCreateWholesaler = (postData) => {
  let { url, query } = config.registration.wholesaler

  return axios.post(
    url,
    {
      query: query,
      variables: postData,
    },
    {
      withCredentials: true,
    }
  )
}

export const axiosCreateSupplierEnquiry = (postData) => {
  const { url, query } = config.registration.supplier

  return axios.post(
    url,
    {
      query: query,
      variables: postData,
    },
    {
      withCredentials: true,
    }
  )
}

export const axiosDeleteMember = (id) => {
  let { url, query } = config.members.delete

  return axios.post(
    url,
    {
      query: query,
      variables: {
        ID: id,
      },
    },
    {
      withCredentials: true,
    }
  )
}
export const convertPostDataIntoMutationParams = (postData) => {
  const availableRules = {
    // Key : Type
    ID: 'ID!',
    FirstName: 'String',
    VenueName: 'String',
    PhoneNumber: 'String',
    Position: 'String',
    Surname: 'String',
    Mobile: 'String',
    Password: 'String',
    ConfirmPassword: 'String',
    DeliveryDays: 'String',
    DeliveryTime: 'String',
    CompanyName: 'String',
    DP_PreferredDeliveryDay: 'String',
    IsConsolidationEnabled: 'Boolean',
    PreferredDeliveryDays: 'String',
    PreferredDeliveryTimes: 'String',
    PreferredDeliveryTimes2: 'String',
    ViewInvoices: 'Boolean',
    ViewReports: 'Boolean',
    OrderByCreditCard: 'Boolean',
    NotifyRestockViaEmail: 'Boolean',
    AccountReminderViaSMS: 'Boolean',
    NotifyRestockViaSMS: 'Boolean',
    Permissions: '[String]',
    Email: 'String',
    ConfirmEmail: 'String',
    DefaultLocationForSupplier: 'String',
    HideQLDCustomerPopup: 'Boolean',
    Is3PLMEL: 'Boolean',
    Is3PLSYD: 'Boolean',
    Is3PLADE: 'Boolean',
    Is3PLBRIS: 'Boolean',
    Is3PLCAI: 'Boolean',
  }

  let selectedRules = []
  let selectedParams = []

  let finalData = {}

  Object.entries(availableRules).map(([postDataKey, postDataValue]) => {
    if (postData[postDataKey] !== undefined) {
      selectedRules.push(`$${postDataKey}: ${postDataValue}`)
      selectedParams.push(`${postDataKey}: $${postDataKey}`)

      finalData[postDataKey] = postData[postDataKey]
    }
  })

  if (postData.Email == postData.ConfirmEmail && postData.Email != postData.ChangeEmail) {
    finalData['Email'] = postData.Email
    finalData['ConfirmEmail'] = postData.ConfirmEmail
  } else {
    delete finalData['Email']
    delete finalData['ConfirmEmail']
  }

  return [`MemberInfo(${selectedRules.join(', ')})`, `Input: {${selectedParams.join(', ')}}`, finalData]
}
export const convertUpdateMemberPostData = (postData) => {
  const data = { ...postData }

  /**
   * Helper function to convert "unique array" into normal array
   * @param d
   * @param key
   * @returns {string|boolean}
   */
  const convertIntoArray = (d, key) => {
    let tmp = []
    let exists = false

    Object.entries(d).forEach(([dataKey, dataValue]) => {
      if (dataKey.indexOf(`${key}[`) !== -1) {
        exists = true
        const subdataKey = dataKey.replace(`${key}[`, '').replace(']', '')

        if (dataValue === true) {
          tmp.push(subdataKey)
        }
      }
    })

    if (!exists) return false

    return tmp
  }

  /**
   * Helper function to convert "unique array" into comma separated value
   *
   * @param d
   * @param key
   * @returns {string|boolean}
   */
  const convertIntoCommaSeparated = (d, key) => {
    const result = convertIntoArray(d, key)

    return Array.isArray(result) ? result.join(',') : false
  }

  // remove password if not provided;
  if (data.Password === '') {
    delete data.Password
    delete data.ConfirmPassword
  }

  if (data.Email === '') {
    delete data.Email
    delete data.ConfirmEmail
  }

  // Preferred Delivery
  ;['PreferredDeliveryDays', 'PreferredDeliveryTimes', 'PreferredDeliveryTimes2'].forEach((itemKey) => {
    const result = convertIntoCommaSeparated(data, itemKey)

    if (result !== false) {
      data[itemKey] = result
    }
  })
  ;['Permissions'].forEach((itemKey) => {
    const result = convertIntoArray(data, itemKey)

    if (result !== false) {
      data[itemKey] = result
    }
  })

  return data
}

export const loadPdf = () => {
  return function (dispatch) {
    return axios
      .get(config.viewStatementPdfLink.url)
      .then((response) => {
        response = response.data
        dispatch(setPdfStatementLink(response))
        dispatch(togglePdfStatementLoading(false))
        return response
      })
      .catch((error) => {
        handleAxiosErrors(error)
        return
      })
  }
}

export const loadPdfUrl = (url) => {
  return function (dispatch) {
    dispatch(togglePdfViewModal(true))
    dispatch(togglePdfViewModalLoading(true))
    return axios
      .get(url)
      .then((response) => {
        const { data } = response
        if (data.Status) {
          dispatch(setPdfViewData(data))
          dispatch(togglePdfViewModalLoading(false))
        }
      })
      .catch((error) => {
        dispatch(togglePdfViewModalLoading(false))
        handleAxiosErrors(error)
      })
  }
}

export const searchInvoicesLoadPdfUrl = (param) => {
  return function (dispatch) {
    dispatch(togglePdfViewModal(true))
    dispatch(togglePdfViewModalLoading(true))
    if (!Array.isArray(param)) {
      return axios
        .get(param, {
          responseType: 'blob',
        })
        .then((response) => {
          let newBlob = new Blob([response?.data], { type: 'application/pdf' })
          let newData = URL.createObjectURL(newBlob)

          if (response?.data) {
            dispatch(setPdfViewData({ Link: newData }))
            dispatch(togglePdfViewModalLoading(false))
          }
        })
        .catch((error) => {
          dispatch(togglePdfViewModalLoading(false))
          handleAxiosErrors(error)
        })
    } else {
      const urls = param.map((item) => item?.PODLink)
      dispatch(setPdfViewData({ Link: urls }))
      dispatch(togglePdfViewModalLoading(false))
      return true
    }
  }
}

export const updateLoyaltyModalDetail = (flag, isLoyaltyBoxPage) => {
  return (dispatch, getState) => {
    //Logic for handling Loyalty Box
    dispatch(updateUserDetail('showLoyaltyModal', flag))
    let loyaltyModalDisplayed = {
      all: 1,
    }
    if (isLoyaltyBoxPage) {
      loyaltyModalDisplayed.loyaltyBox = 1
    }
    localStorage.setItem('loyaltyModalDisplayed', JSON.stringify(loyaltyModalDisplayed))
    if (flag) {
      window.location.href = '/loyalty-box-survey'
    }
  }
}

export const showLoyaltyModal = (count) => {
  const currentURL = window.location.href.split('/')
  const isLoyaltyBoxPage = currentURL.includes('loyalty-box')
  if (isLoyaltyBoxPage && count != -1) {
    return true
  }
  return count <= 3 && count != -1 ? true : false
}

export const postPopupManagerData = (params) => {
  let url = `${window.baseURL}popup/impression`
  const { PopupID, Complete } = params

  //Form data for impressions count
  let formData = new FormData()
  formData.append('PopupID', PopupID)
  formData.append('Complete', Complete)

  return axios({
    method: 'post',
    url: url,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data', withCredentials: true },
  })
}

export const postBannerManagerData = (params) => {
  let { url, query } = config.bannerManager.impressions

  return axios.post(
    url,
    {
      query: query,
      variables: { ...params },
    },
    {
      withCredentials: true,
    }
  )
}

export const forceLoginSupplier = (selectedUser) => {
  return (dispatch, getState) => {
    const store = getState()

    if (store.isLoading) {
      return
    }

    dispatch(toggleLoading(true))

    const selectedUserID = typeof selectedUser.value != 'undefined' ? selectedUser.value : 0
    let { url, query } = config.members.impersonateUser

    return axios
      .post(
        url,
        {
          query: query,
          variables: {
            MemberID: selectedUserID,
          },
        },
        {
          withCredentials: true,
        }
      )
      .then(async (response) => {
        dispatch(toggleLoading(false))

        //Remove config of previous logged in supplier from local storage
        localStorage.removeItem('globalConfig' + window.currentMemberID)
        const { data } = response

        if (response.data.data.ImpersonateUser !== null) {
          LS.set('triggeredDiscount', false)

          setTimeout(() => {
            window.location.href = '/supplier'
          }, 300)
        } else {
          createAlert(data, 'error')
        }
      })
      .catch((error) => {
        dispatch(toggleLoading(false))
        handleAxiosErrors(error)
      })
  }
}

export const axiosUploadImages = async (file) => {
  // if (file?.thumbnail) {
  //   return parseInt(file.id, 10)
  // }

  const { url } = config.image.upload

  const formData = new FormData()

  // if (typeof window.securityToken != 'undefined') {
  //   formData.set('SecurityID', window.securityToken)
  // }

  formData.append('Upload', file)

  const response = await axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    withCredentials: true,
  })

  const imageID = response?.data?.ID

  return imageID
}
